import { use_slice_search } from '@/hooks/store/use_slices';
import { ENUM__workspace_entity } from '@shared/dto/+workspace/workspace_entity/_enums/ENUM__workspace_entity';
import { useMemo } from 'react';
import { WatcherTranslateTokensFromEnglishBase } from './WatcherTranslateTokensFromEnglishBase';

export function WatcherTranslateTokensFromEnglishSearch() {
  const { search_current } = use_slice_search(['search_current']);

  const tokens_to_translate = useMemo(() => search_current.tokens, [search_current.tokens]);

  /*
   * HTML
   */

  return (
    <WatcherTranslateTokensFromEnglishBase {...{ tokens_to_translate }} entity_type={ENUM__workspace_entity.ENTITY_SEARCH} entity_id={search_current._id} />
  );
}
